import { envConfig } from "../../utils/constants";
import {
  FeatureState,
  FeatureTypeState,
} from "../../utils/interfaces/features";
import { client } from "../graphql";
import { GET_COMPARE_FEATURES, GET_COMPARE_FEATURES_TYPE } from "./queries";

class FeatureServices {
  async getCompareFeatures(
    contentTypeId: Array<Number>
  ): Promise<FeatureState> {
    const res = await client.query({
      query: GET_COMPARE_FEATURES,
      variables: { contentTypeId },
      context: { headers: { store: envConfig.store } },
    });
    return res.data.getCompareFeaturesData;
  }

  async getCompareFeaturesType(): Promise<FeatureTypeState> {
    const res = await client.query({
      query: GET_COMPARE_FEATURES_TYPE,
      context: { headers: { store: envConfig.store } },
      fetchPolicy: "no-cache",
    });
    return res.data.getFeatureContentType;
  }

  setCompareFeatureType = async (
    action: (res: FeatureTypeState) => void,
    callback: (res: any) => void
  ) => {
    await this.getCompareFeaturesType()
      .then((res: any) => {
        if (res) action(res);
        callback(res);
      })
      .catch((e: Error) => {
        callback(e);
      });
  };

  setCompareFeatures = async (
    contentTypeId: Array<Number>,
    action: (res: FeatureState) => void,
    callback: () => void
  ) => {
    await this.getCompareFeatures(contentTypeId)
      .then((res: FeatureState) => {
        if (res) action(res);
        callback();
      })
      .catch((e: Error) => {
        callback();
      });
  };
}

export default new FeatureServices();
